<template>
    <div class="cms-container">
        <ToastCMS ref="toast" />
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <!-- Show video or image depending on what is being previewed -->
                        <video v-if="previewIsVideo" :src="previewImages" controls muted
                            style="max-width:70vw; max-height:70vh; display:block; margin:0 auto;"></video>
                        <img v-else :src="previewImages" alt="Preview Image">
                    </div>
                </div>

                <div class="text-center mt-3">
                    <span class="text-white">Image 1 of 1</span>
                </div>
            </div>
        </div>
        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between mb-3 px-3">
                <div class="crew-fleet-header text-dark">
                    Crew and Fleet Status
                </div>
                <button type="button" @click="clearText" class="vmc-bg-prime-6 text-white border-0 rounded px-2 py-1">
                    Clear Text
                </button>
            </div>
        </div>
        <form action="" id="crewfleet" @submit.prevent="saveAllChanges">
            <div class="px-3">
                <!-- BACKGROUND MEDIA UPLOAD -->
                <div class="mt-3">
                    <div class="d-flex align-items-center justify-content-between w-100 my-2">
                        <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                            <span class="logo-number text-dark">
                                Background Media (MP4 or Image, Max 10MB)
                            </span>
                            <div class="d-flex align-items-center" style="gap:5px;">
                                <button type="button" @click="previewBgMedia"
                                    class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                    View
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">

                        <video v-if="homeBackgroundVideo" :src="homeBackgroundVideo" class="w-100 h-100" controls muted
                            style="object-fit:contain;"></video>
                        <img v-else-if="homeBackgroundImage" :src="homeBackgroundImage" class="w-100 h-100"
                            style="object-fit:contain;">

                        <template v-else>
                            <input type="file" id="upload-crewfleet-bg"
                                accept="video/mp4, image/png, image/jpeg, image/jpg" hidden
                                @change="onBgMediaChange($event)">
                            <label for="upload-crewfleet-bg"
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                style="cursor:pointer;">
                                <i class="material-symbols-outlined">upload</i>
                                <span>Upload Background (MP4 or Image)</span>
                            </label>
                        </template>
                    </div>
                    <button @click="removeBgMedia" type="button"
                        class="w-100 vmc-bg-prime-6 py-1 text-white mt-1 border-0 rounded">
                        Remove Media
                    </button>
                </div>

                <div class="number-inputs align-items-center justify-content-center" style="margin-top: 40px;">
                    <div class="input-group" style="margin-bottom: 25px;">
                        <input type="number" class="input-field w-100 text-dark p-2" v-model="onBoard"
                            style="resize:none;" placeholder="">
                        <label class="floating-label">On Board</label>
                    </div>
                    <div class="input-group" style="margin-bottom: 25px;">
                        <input type="number" class="input-field w-100 text-dark p-2" v-model="standBy"
                            style="resize:none;" placeholder="">
                        <label class="floating-label">Stand By</label>
                    </div>
                    <div class="input-group" style="margin-bottom: 25px;">
                        <input type="number" class="input-field w-100 text-dark p-2" v-model="totalVessels"
                            style="resize:none;" placeholder="">
                        <label class="floating-label">Total Vessel</label>
                    </div>
                </div>
                <div class="img-desc d-flex align-items-center justify-content-center">
                    <div class="d-block mt-1 w-100">
                        <label class="text-dark">Description:</label>
                        <textarea rows="7" class="text-dark w-100" style="border:1px solid gray; resize:none;"
                            placeholder="Description of the image uploaded" v-model="cfsimgdesc"></textarea>
                    </div>
                </div>

                <div class="mt-3">
                    <div class="d-flex align-items-center justify-content-between w-100 my-2">
                        <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                            <span class="logo-number text-dark">
                                Logo Image
                            </span>
                            <div class="d-flex align-items-center" style="gap:5px;">
                                <button type="button" @click="previewImage"
                                    class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                    View
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">

                        <img v-if="images" :src="images" alt="Slide Image"
                            style="height:100%; width:100%; object-fit:contain;">

                        <template v-else>
                            <input type="file" :id="'upload-crewfleet-img'" accept="image/png, image/jpeg, image/jpg"
                                hidden @change="onImageChange($event)">
                            <label :for="'upload-crewfleet-img'"
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                style="cursor:pointer;">
                                <i class="material-symbols-outlined">upload</i>
                                <span>Upload Photo</span>
                            </label>
                        </template>
                    </div>
                    <button @click="resetImage" type="button"
                        class="w-100 vmc-bg-prime-6 py-1 text-white mt-1 border-0 rounded">
                        Remove Photo
                    </button>
                </div>
            </div>
        </form>
        <div class="my-4 px-3">
            <button type="submit" form="crewfleet" class="vmc-bg-prime-4 border-0 px-3 py-1 text-white mx-1 rounded">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "CrewAndFleetStatusCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            images: null,
            previewImages: null,
            previewIsVideo: false,
            showPreviewModal: false,
            onBoard: '',
            standBy: '',
            totalVessels: '',
            cfsimgdesc: '',
            homeBackgroundVideo: '',
            homeBackgroundImage: '',
            originalOnBoard: '',
            originalStandBy: '',
            originalTotalVessels: '',
            originalCfsimgdesc: '',
            originalImages: null,
            originalHomeBackgroundVideo: '',
            originalHomeBackgroundImage: ''
        }
    },
    methods: {
        clearText() {
            const isEmpty =
                (!this.onBoard || String(this.onBoard).trim() === "") &&
                (!this.standBy || String(this.standBy).trim() === "") &&
                (!this.totalVessels || String(this.totalVessels).trim() === "") &&
                (!this.cfsimgdesc || this.cfsimgdesc.trim() === "");

            this.onBoard = "";
            this.standBy = "";
            this.totalVessels = "";
            this.cfsimgdesc = "";

            if (isEmpty) {
                this.$refs.toast.showToast('Has no text', "warning");
            } else {
                this.$refs.toast.showToast('Cleared all text', "success");
            }
        },

        async onImageChange(e) {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                // Short link saved instead of Base64
                this.images = data.url;
                this.$refs.toast.showToast('Image has been attached', "success");
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
    e.target.value = "";
},

        resetImage() {
            if (!this.images) {
                this.$refs.toast.showToast('Has no image attached', "warning");
                return;
            }
            this.images = null;
            const input = document.getElementById('upload-crewfleet-img');
            if (input) input.value = "";
            this.$refs.toast.showToast('Image has been removed', "error");
        },

        previewImage() {
            if (!this.images) {
                this.$refs.toast.showToast("No image to view", "warning");
                return;
            }
            this.previewImages = this.images;
            this.previewIsVideo = false;
            this.showPreviewModal = true;
        },

        previewBgMedia() {
            if (!this.homeBackgroundVideo && !this.homeBackgroundImage) {
                this.$refs.toast.showToast("No background media to view", "warning");
                return;
            }
            if (this.homeBackgroundVideo) {
                this.previewImages = this.homeBackgroundVideo;
                this.previewIsVideo = true;
            } else {
                this.previewImages = this.homeBackgroundImage;
                this.previewIsVideo = false;
            }
            this.showPreviewModal = true;
        },

        removeBgMedia() {
            if (!this.homeBackgroundVideo && !this.homeBackgroundImage) {
                this.$refs.toast.showToast("No background media to remove", "warning");
                return;
            }
            this.homeBackgroundVideo = '';
            this.homeBackgroundImage = '';
            this.$refs.toast.showToast("Background media removed", "error");
        },

        async onBgMediaChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
        this.$refs.toast.showToast("File is too large! Max 10MB.", "error");
        e.target.value = "";
        return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            if (file.type.startsWith('video/')) {
                this.homeBackgroundVideo = data.url;
                this.homeBackgroundImage = '';
            } else if (file.type.startsWith('image/')) {
                this.homeBackgroundImage = data.url;
                this.homeBackgroundVideo = '';
            }
            this.$refs.toast.showToast("Background media attached", "success");
        } else {
            console.error("Upload failed:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
    e.target.value = "";
},

        onKeyboard(e) {
            if (this.showPreviewModal && e.key === 'Escape') {
                this.showPreviewModal = false;
            }
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = null;
            this.previewIsVideo = false;
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch content");

                const data = await response.json();

                if (data && Object.keys(data).length > 0) {
                    this.onBoard = data.onBoard ?? '';
                    this.standBy = data.standBy ?? '';
                    this.totalVessels = data.totalVessels ?? '';
                    this.cfsimgdesc = data.cfsimgdesc ?? '';
                    this.homeBackgroundVideo = data.homeBackgroundVideo ?? '';
                    this.homeBackgroundImage = data.homeBackgroundImage ?? '';

                    if (data.homeCrewFleetStatusLogo && data.homeCrewFleetStatusLogo.image) {
                        this.images = data.homeCrewFleetStatusLogo.image;
                    }
                }

                // Snapshots for hasChanges
                this.originalOnBoard = this.onBoard;
                this.originalStandBy = this.standBy;
                this.originalTotalVessels = this.totalVessels;
                this.originalCfsimgdesc = this.cfsimgdesc;
                this.originalImages = this.images;
                this.originalHomeBackgroundVideo = this.homeBackgroundVideo;
                this.originalHomeBackgroundImage = this.homeBackgroundImage;

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges(e) {
            e.preventDefault();

            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save", "warning");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        onBoard: this.onBoard,
                        standBy: this.standBy,
                        totalVessels: this.totalVessels,
                        cfsimgdesc: this.cfsimgdesc,
                        homeCrewFleetStatusLogo: { image: this.images },
                        homeBackgroundVideo: this.homeBackgroundVideo,
                        homeBackgroundImage: this.homeBackgroundImage
                    })
                });

                if (!response.ok) throw new Error("Server error");

                // Update snapshots
                this.originalOnBoard = this.onBoard;
                this.originalStandBy = this.standBy;
                this.originalTotalVessels = this.totalVessels;
                this.originalCfsimgdesc = this.cfsimgdesc;
                this.originalImages = this.images;
                this.originalHomeBackgroundVideo = this.homeBackgroundVideo;
                this.originalHomeBackgroundImage = this.homeBackgroundImage;

                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadFormData();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        hasChanges() {
            return (
                this.onBoard !== this.originalOnBoard ||
                this.standBy !== this.originalStandBy ||
                this.totalVessels !== this.originalTotalVessels ||
                this.cfsimgdesc !== this.originalCfsimgdesc ||
                this.images !== this.originalImages ||
                this.homeBackgroundVideo !== this.originalHomeBackgroundVideo ||
                this.homeBackgroundImage !== this.originalHomeBackgroundImage
            );
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 50;
    background-color: white;
}

@media (min-width: 330px) {
    .main-header {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        padding: 15px 0;
    }

    .crew-fleet-header {
        font-size: 17px;
        font-weight: 600;
    }

    .img-container {
        width: 100%;
        height: 140px;
        background-position: center;
    }

    .photo-img {
        width: 100%;
        height: 140px;
        cursor: pointer;
    }

    textarea {
        resize: none;
    }

    input,
    textarea {
        font-size: 15px;
        outline: none;
    }

    button {
        font-size: 16px;
    }

    input {
        height: 36px;
    }

    .input-group {
        position: relative;
        display: flex;
    }

    .input-field {
        border: 1px solid gray;
        border-radius: 4px !important;
        width: 100%;
        outline: none;
    }

    .floating-label {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        color: gray;
        background-color: white;
        transition: all 0.3s ease;
        pointer-events: none;
    }

    .input-field:focus~.floating-label,
    .input-field:not(:placeholder-shown)~.floating-label {
        top: 0;
        left: 8px;
        transform: translateY(-50%);
        font-size: 12px;
    }

    .number-inputs {
        display: block;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img,
    .modal-content video {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }
}

@media (min-width: 768px) {
    .crew-fleet-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {

    .number-inputs,
    .img-desc {
        display: flex;
        gap: 10px;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .img-container {
        width: 330px;
        height: 140px;
        background-position: center;
    }

    .photo-img {
        width: 330px;
        height: 140px;
        cursor: pointer;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>